import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import SelectorPanel from './SelectorPanel'
import { MobileDrawerPanel } from '../../core/application/types'
import SearchPanel from './SearchPanel'
import SubmitPanel from './SubmitPanel'
import { DownChevronIcon } from '../icons'
import { useConfigurationContext, useDropOffLocationContext, useModalContext } from '../../core/application/contexts'
import DropOffDetailPanel from './DropOffDetailPanel'
import { DropOffLocation } from '../../core/domain/models'


const BottomDrawer = () => {
  const { wasteTypeList } = useConfigurationContext()
  const { setWasteTypeFilterModal } = useModalContext()
  const {
    dropOffLocationList,
    currentDropOffLocation,
    setCurrentDropOffLocation,
    setDisplaySubmitDropoffScreen
  } = useDropOffLocationContext()
  const [isOpen, setIsOpen] = useState<boolean>(true)
  const [currentPanel, setCurrentPanel] = useState<MobileDrawerPanel>(MobileDrawerPanel.SELECTOR_PANEL)

  const handleSelectDropOff = (location: DropOffLocation) => {
    const dropOff = dropOffLocationList.find(it => it.storeId === location.storeId)
    if (dropOff) {
      setCurrentDropOffLocation(dropOff)
    }
  }

  const handleOnReturn = () => {
    if (currentDropOffLocation) {
      setCurrentDropOffLocation(undefined)
      setCurrentPanel(MobileDrawerPanel.SEARCH_PANEL)
    } else {
      setCurrentPanel(MobileDrawerPanel.SELECTOR_PANEL)
    }
  }

  const handlePanelSelection = (panel: MobileDrawerPanel) => {
    if (panel === MobileDrawerPanel.SORT_PANEL) {
      setWasteTypeFilterModal(true)
    } else if (panel === MobileDrawerPanel.SUBMIT_PANEL) {
      setDisplaySubmitDropoffScreen(true)
    } else {
      setWasteTypeFilterModal(false)
      setCurrentPanel(panel)
      setIsOpen(true)
    }
  }

  const fullSize = [MobileDrawerPanel.SUBMIT_PANEL, MobileDrawerPanel.DROPOFF_DETAIL_PANEL].includes(currentPanel)

  if (currentDropOffLocation) {
    return (
      <Container data-testid='bottomDrawer' isOpen={isOpen} fullSize={true}>
        <DropOffDetailPanel
          dropOffLocation={{
            id: currentDropOffLocation.storeId,
            types: currentDropOffLocation.types,
            name: currentDropOffLocation.name,
            address: currentDropOffLocation.address,
            coordinate: currentDropOffLocation.coordinate,
            pictures: currentDropOffLocation.pictures,
            schedule: currentDropOffLocation.schedule,
            phone: currentDropOffLocation.contact?.phone,
            availableWasteTypes: currentDropOffLocation.acceptedWasteIds,
            website: currentDropOffLocation.contact?.website,
            isOpenNow: currentDropOffLocation.isOpenNow
          }}
          onReturn={() => setCurrentDropOffLocation(undefined)} />
      </Container>

    )
  }

  return (
    <Container data-testid='bottomDrawer' isOpen={isOpen} fullSize={fullSize}>
      <Toggler visible={fullSize === false} isOpen={isOpen} onClick={() => setIsOpen(value => !value)}>
        <DownChevronIcon />
      </Toggler>
      {currentPanel === MobileDrawerPanel.SELECTOR_PANEL &&
        <SelectorPanel onClick={handlePanelSelection} wasteTypeList={wasteTypeList} />}
      {currentPanel === MobileDrawerPanel.SEARCH_PANEL &&
        <SearchPanel
          dropOffLocationList={dropOffLocationList}
          // mostPopularSearchTerms={mostPopularSearches}
          togglePanel={(value) => setIsOpen(value)}
          onSelect={handleSelectDropOff}
          onReturn={handleOnReturn} />}
      {currentPanel === MobileDrawerPanel.SUBMIT_PANEL && <SubmitPanel />}
    </Container>
  )
}

interface IWithOpen {
  isOpen?: boolean
}


interface IContainerProps extends IWithOpen {
  fullSize: boolean
}

const Container = styled.div<IContainerProps>`
  position: absolute;
  left: 0;
  right: 0;
  z-index: 3;
  bottom: ${({ isOpen }) => isOpen ? '0' : '-160px'};
  transition: all 250ms linear;

  ${({ fullSize }) => fullSize && css`
    top: 0 !important;
    bottom: 0 !important;
    background-color: ${({ theme }) => theme.color.background};
  `}
`


interface ITogglerProps extends IWithOpen {
  visible: boolean
}

const Toggler = styled.button<ITogglerProps>`
  position: absolute;
  background-color: ${({ theme }) => theme.color.primary};
  display: ${({ visible }) => visible ? 'flex' : 'none'};
  border-radius: 50%;
  height: 26px;
  width: 26px;
  top: -15px;
  margin-left: -13px;
  left: 50%;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.55);
  z-index: 10;
  cursor: pointer;

  svg {
    transform: ${({ isOpen }) => isOpen ? 'unset' : 'rotate(180deg)'};
    transition: all 250ms linear;

    path {
      fill: ${({ theme }) => theme.color.secondary};
    }
  }
`


export default BottomDrawer
